import api from './api'

class MetricsService {
    getSubscriptionMetrics = (subscriptionId: string) => {
        const url = `/tenants/subscriptions/metrics?ids=${subscriptionId}`
        return api.get(url)
    }
}

export default new MetricsService();